import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AddAssessment from './components/questions/AddAssessment';
import { useRouter } from 'next/router';
import AssessmentQuestions from './components/questions/AssessmentQuestions';
import useWidth from '@/helpers/widthUtil';

const Assessment = ({ roomSlug, roomId, courseSlug }) => {
  const router = useRouter();
  const { isMobile, isTablet } = useWidth();
  const [addVisible, setAddVisible] = useState(false);

  const { assessments, meta, user } = useSelector((state: any) => ({
    assessments: state?.roomReducer?.assessment?.data,
    meta: state?.roomReducer?.assessment?.meta,
    user: state.auth?.creds?.user_data?.user_type,
  }));

  const handleCancel = () => {
    setAddVisible(false);
  };
  const isStaff = user === 'staff' || user === 'instructor';

  return (
    <>
      <Modal
        visible={addVisible}
        title="Add Assessment"
        footer={null}
        onCancel={handleCancel}
        width={1000}
        maskClosable={false}
      >
        <AddAssessment
          roomSlug={roomSlug}
          roomId={roomId}
          courseSlug={courseSlug}
          handleCancel={handleCancel}
        />
      </Modal>
      <div className={`container mb-5 ${(isMobile || isTablet) && 'px-0'}`}>
        {isStaff ? (
          <div className="d-flex justify-content-end mb-3">
            <Button
              type="primary"
              onClick={() => setAddVisible(true)}
              style={{ borderRadius: '5px' }}
            >
              + Add New Assessment
            </Button>
          </div>
        ) : (
          ''
        )}
        {router?.query?.tab === 'assessment' && (
          <AssessmentQuestions
            data={assessments}
            roomSlug={roomSlug}
            meta={meta}
            isStaff={isStaff}
            roomId={roomId}
            courseSlug={courseSlug}
          />
        )}
      </div>
    </>
  );
};

export default Assessment;
